/* unplugin-vue-components disabled */import { render } from "./icon_exit.vue?vue&type=template&id=13548e2c&scoped=true"
const script = {}

import "./icon_exit.vue?vue&type=style&index=0&id=13548e2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13548e2c"]])

export default __exports__